import type { StateData } from '@/lib/become-an-agent-types';

function formatDate(iso: string | null): string | null {
    if (!iso) return null;
    return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export function PageFooter({ state }: { state: StateData }) {
    const reviewedDate = formatDate(state.last_reviewed_at) ?? formatDate(state.content_updated_at);
    return (
        <section className="bg-[#fdfaf3] border-t border-[#0b2222]/10">
            <div className="mx-auto max-w-3xl px-6 py-10 text-sm text-[#0b2222]/60 sm:py-12">
                {reviewedDate && (
                    <div className="mb-3">
                        <span className="lux-caps lux-caps-sm">Last reviewed:</span> {reviewedDate}
                    </div>
                )}
                <div className="mb-6">
                    <span className="lux-caps lux-caps-sm">By:</span> the LuxRally Travel Editorial Team
                </div>
                <p className="leading-relaxed">
                    This information is for general guidance only and is not legal, tax, or business advice. State regulations
                    change. Consult a qualified attorney or accountant for your specific situation.
                </p>
            </div>
        </section>
    );
}
